import { render, staticRenderFns } from "./statistics2.vue?vue&type=template&id=20e8cb78&scoped=true"
import script from "./statistics2.vue?vue&type=script&lang=js"
export * from "./statistics2.vue?vue&type=script&lang=js"
import style0 from "./statistics2.vue?vue&type=style&index=0&id=20e8cb78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e8cb78",
  null
  
)

export default component.exports